import React from 'react';

const Hide = ({
  children,
  hide,
}: {
  children: React.ReactNode;
  hide: boolean;
}) => {
  if (hide) return null;

  return <>{children}</>;
};

export default Hide;
